import React, { PureComponent } from 'react'
import {connect} from "react-redux";

import Header from "../../components/Headers/Header";
import {Button, Card, CardBody, CardHeader, Col, Container, Row} from "reactstrap";
import { withLocalize } from "react-localize-redux";
import { Translate } from "react-localize-redux";

import italianCorporateDetailTranslations from "../../translations/corporate/detail/it.corporate.detail.json";
import englishCorporateDetailTranslations from "../../translations/corporate/detail/en.corporate.detail.json";

class CorporateDetail extends PureComponent {
  constructor(props) {
    super(props);

    this.props.addTranslationForLanguage(italianCorporateDetailTranslations, "it");
    this.props.addTranslationForLanguage(englishCorporateDetailTranslations, "en");
  }

  onBackClick = () => {
    this.props.history.goBack();
  }

  render() {
    return (
        <>
          <Header />
          <Container className="mt--5" fluid>
            <Row>
              <div className="col" style={{paddingBottom:"2%"}}>
                <Card className="shadow">
                  <CardHeader className="border-0">
                    <Row>
                      <div className="col">
                        <h3 className="mb-0">
                          <Translate id="corporate.detail.title" data={{ corporateSenderName: this.props.corporateSenderName }}/>
                        </h3>
                      </div>
                    </Row>
                  </CardHeader>
                  <CardBody>
                    <div className="align-items-center table-flush">
                      <Row>
                        <Col>
                          {/*corporateSenderId*/}
                          <Row>
                            <Col>
                              <b>
                                <Translate id="corporate.detail.sender.id" />
                              </b>
                            </Col>
                            <Col>
                              {this.props.corporateSenderId}
                            </Col>
                          </Row>
                          {/*corporateSenderName*/}
                          <hr className="my-1" />
                          <Row>
                            <Col>
                              <b>
                                <Translate id="corporate.detail.sender.name" />
                              </b>
                            </Col>
                            <Col>
                              {this.props.corporateSenderName}
                            </Col>
                          </Row>
                          {/*enabled*/}
                          <hr className="my-1" />
                          <Row>
                            <Col>
                              <b>
                                <Translate id="corporate.detail.enabled" />
                              </b>
                            </Col>
                            <Col>
                              {this.props.enabled === true ? 'True' : 'False'}
                            </Col>
                          </Row>
                          {/*campaigns*/}
                          <hr className="my-1" />
                          <Row>
                            <Col>
                              <b>
                                <Translate id="corporate.detail.campaign" />
                              </b>
                            </Col>
                            <Col>
                              <ul>
                                {this.props.campaigns.map((campaign) =>
                                    <li key={campaign.idLogo}>{campaign.idLogo} - {campaign.campaignName}</li>
                                )}
                              </ul>
                            </Col>
                          </Row>
                          {/*contiCorrenti*/}
                          <hr className="my-1" />
                          <Row>
                            <Col>
                              <b>
                                <Translate id="corporate.detail.contoCorrente" />
                              </b>
                            </Col>
                            <Col>
                              <ul>
                                {this.props.contiCorrenti.map((contoCorrente) =>
                                    <li key={contoCorrente.id}>{contoCorrente.contoCorrente} - {contoCorrente.senderAccount} - {contoCorrente.note} - {contoCorrente.enabled === true ? "True" : "False"}</li>
                                )}
                              </ul>
                            </Col>
                          </Row>
                          {/*bank*/}
                          <hr className="my-1" />
                          <Row>
                            <Col>
                              <b>
                                <Translate id="corporate.detail.bank" />
                              </b>
                            </Col>
                            <Col>
                              {this.props.bank}
                            </Col>
                          </Row>
                          {/*logo*/}
                          <hr className="my-1" />
                          <Row>
                            <Col>
                              <b>
                                <Translate id="corporate.detail.image" />
                              </b>
                            </Col>
                            <Col>
                              <img alt="" src={this.props.logo} width="150" className="img-rounded"/>
                            </Col>
                          </Row>
                          {/*autoAccept*/}
                          <hr className="my-1" />
                          <Row>
                            <Col>
                              <b>
                                <Translate id="corporate.detail.autoAccept" />
                              </b>
                            </Col>
                            <Col>
                              {this.props.autoAccept === true ? 'True' : 'False'}
                            </Col>
                          </Row>
                          {/*timeToExpiry*/}
                          <Row>
                            <Col>
                              <b>
                                <Translate id="corporate.detail.timeToExpiry" />
                              </b>
                            </Col>
                            <Col>
                              {this.props.timeToExpiry}
                            </Col>
                          </Row>
                          {/*daysToFirstReminder*/}
                          <Row>
                            <Col>
                              <b>
                                <Translate id="corporate.detail.daysToFirstReminder" />
                              </b>
                            </Col>
                            <Col>
                              {this.props.daysToFirstReminder}
                            </Col>
                          </Row>
                          {/*daysToSecondReminder*/}
                          <Row>
                            <Col>
                              <b>
                                <Translate id="corporate.detail.daysToSecondReminder" />
                              </b>
                            </Col>
                            <Col>
                              {this.props.daysToSecondReminder}
                            </Col>
                          </Row>
                          {/*whatsapp*/}
                          <hr className="my-1" />
                          <Row>
                            <Col>
                              <b>
                                <Translate id="corporate.detail.whatsapp" />
                              </b>
                            </Col>
                            <Col>
                              {this.props.whatsapp === true ? 'True' : 'False'}
                            </Col>
                          </Row>
                          {/*hasBankAuthorizer*/}
                          <hr className="my-1" />
                          <Row>
                            <Col>
                              <b>
                                <Translate id="corporate.detail.hasBankAuthorizer" />
                              </b>
                            </Col>
                            <Col>
                              {this.props.hasBankAuthorizer === true ? 'True' : 'False'}
                            </Col>
                          </Row>
                          <Row>
                            <Col align="left">
                              <Button onClick={this.onBackClick} variant="contained">
                                <i className="fas fa-arrow-left text-primary" />
                              </Button>
                            </Col>
                          </Row>
                        </Col>
                        <Col></Col>
                      </Row>
                    </div>
                  </CardBody>
                </Card>
              </div>
            </Row>
          </Container>
        </>
    );
  }
}

const mapStateToProps = state => {
  return {
    corporateSenderId: state.corporateDetail.corporateDetail.corporateSenderId,
    corporateSenderName: state.corporateDetail.corporateDetail.corporateSenderName,
    enabled: state.corporateDetail.corporateDetail.enabled,
    campaigns: state.corporateDetail.corporateDetail.campaigns,
    contiCorrenti: state.corporateDetail.corporateDetail.contiCorrenti,
    bank: state.corporateDetail.corporateDetail.bank,
    logo: state.corporateDetail.corporateDetail.logo,
    autoAccept: state.corporateDetail.corporateDetail.autoAccept,
    timeToExpiry: state.corporateDetail.corporateDetail.timeToExpiry,
    daysToFirstReminder: state.corporateDetail.corporateDetail.daysToFirstReminder,
    daysToSecondReminder: state.corporateDetail.corporateDetail.daysToSecondReminder,
    whatsapp: state.corporateDetail.corporateDetail.whatsapp,
    hasBankAuthorizer: state.corporateDetail.corporateDetail.hasBankAuthorizer
  }
}

const mapDispatchToProps = dispatch => {
  return {

  }
}

export default withLocalize(connect(mapStateToProps, mapDispatchToProps)(CorporateDetail));